export const shouldShowActiveBonusPopover = (notifications?: any) =>
  Boolean(
    notifications?.bonus?.isActive &&
      (notifications?.bonus?.giftspins === 0 || notifications?.bonus?.giftspins)
  );
